import { useFormik } from 'formik';
import { FormValues } from '../types/userDetailFormValues';
import { InputProps as StandardInputProps } from '@mui/material/Input/Input';
import React, { useEffect, useState } from 'react';
import { Fade } from '@mui/material';
import BorderedSection from '../../shared/borderedSection';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useProperties, ManagedProperty } from '../../../system/EntityManager';

interface ManagerState {
  properties: Partial<ManagedProperty>[];
  selectedPropertyIds: string[];
}

export function UserManagerTab(props: {
  formik: ReturnType<typeof useFormik<FormValues>>;
  onChange: StandardInputProps['onChange'];
}) {
  const {
    formik,
    // TODO: Peter: if we don't need onChange as a prop, delete it.
    // onChange,
  } = props;
  const [managerState, setManagerState] = useState<ManagerState>({
    properties: [],
    selectedPropertyIds: [],
  });

  const { properties } = useProperties();
  // const { data } = useAuthorizationOptionsQuery();

  useEffect(() => {
    let selectedPropertyIds: string[] = [];
    if (properties.length) {
      selectedPropertyIds = properties
        .filter((prop) => formik.values.managerProperties.includes(prop._id))
        .map((prop) => prop._id);
    }
    setManagerState({ properties, selectedPropertyIds });
  }, [properties, formik]);

  return (
    <Fade in={true} style={{ transitionDuration: '1100ms' }}>
      <div
        style={{
          width: '100%',
        }}
      >
        <h2 style={{ margin: 0, marginBottom: '20px' }}>Manager Settings</h2>
        <div>
          <BorderedSection
            title="Properties managed by this user"
            error={!!formik.errors.managerProperties}
            hint={formik.errors.managerProperties || ''}
          >
            <FormGroup style={{ marginTop: '-6px', marginLeft: '6px' }}>
              {managerState.properties.length
                ? managerState.properties.map((property) => {
                    return property._id ? (
                      <FormControlLabel
                        key={property._id}
                        onChange={(e, checked) => {
                          e.preventDefault();
                          formik.setFieldTouched('managerProperties');
                          const newPropIds = checked
                            ? [...formik.values.managerProperties, property._id]
                            : formik.values.managerProperties.filter(
                                (id) => id !== property._id,
                              );
                          formik.setFieldValue('managerProperties', newPropIds);
                        }}
                        control={
                          <Checkbox
                            id={property._id}
                            value={property._id}
                            checked={managerState.selectedPropertyIds.includes(
                              property._id,
                            )}
                          />
                        }
                        label={property.title || 'no title property'}
                      />
                    ) : null;
                  })
                : null}
            </FormGroup>
          </BorderedSection>
        </div>
      </div>
    </Fade>
  );
}
